import {getQuotationCategory, createOrUpdateCategory, delCategory} from '@/api/quotation';
import { v4 as uuidv4 } from 'uuid';

type ICategoryInfo = IQuotation.IResponse.ICategoryInfo;

interface ICategoryManage {
  data: ICategoryInfo[];
  requestGetCategorys(): Promise<string>;
  requestUpdateCategory(category: IQuotation.IRequest.IUpdateCategory): Promise<string>;
  requestDelCategory(categoryId: string): Promise<string>;
  createCategory(): ICategoryInfo;
  updateCategory(category: ICategoryInfo): void;
  addCategory(category: ICategoryInfo): void;
  deleteCategory(categoryId: string): void;
}

export const categoryManage: ICategoryManage = {
  data: [],
  requestGetCategorys() {
    return new Promise((resolve, reject) => {
      getQuotationCategory().then((res) => {
        this.data = res.data;
        resolve(res.message);
      }).catch((err) => {
        reject(err.message);
      });
    });
  },
  requestUpdateCategory(category) {
    return new Promise((resolve, reject) => {
      createOrUpdateCategory(category).then((res) => {
        resolve(res.message);
      }).catch((err) => {
        reject(err.message);
      });
    });
  },
  requestDelCategory(categoryId) {
    return new Promise((resolve, reject) => {
      delCategory(categoryId).then((res) => {
        this.deleteCategory(categoryId);
        resolve(res.message);
      }).catch((err) => {
        reject(err.message);
      });
    });
  },
  updateCategory(category) {
    for (let i = 0; i < this.data.length; i++) {
      if (this.data[i].id === category.id) {
        this.data[i] = {...category};
        break;
      }
    }
  },
  createCategory() {
    return {
      id: uuidv4(),
      name: '',
      isAdditional: false,
      isRequired: true,
      active: true,
      projects: [],
    };
  },
  addCategory(category) {
    this.data.unshift(category);
  },
  deleteCategory(categoryId) {
    const index = this.data.findIndex((category) => category.id === categoryId);
    this.data.splice(index, 1);
  },
};
